<template>
  <v-dialog v-model="showModal" width="500px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Dostępne godziny do wybrania</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row v-for="item in godziny_wybieralne" :key="item.id" >
            <v-col cols="4"></v-col>
            <v-col cols="4" style="text-align:center">
              <v-tooltip v-if="item.is_blocked" bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :color="item.is_blocked ? '' : 'success'" ripple v-bind="attrs" v-on="on">{{getFormattedTime(item)}}</v-btn>
                </template>
                <span>{{item.powod}}</span>
              </v-tooltip>
              <v-btn :color="item.is_blocked ? '' : 'success'" v-if="!item.is_blocked" ripple @click="selectTermin(item)">{{getFormattedTime(item)}}</v-btn>
            </v-col>
            <v-col cols="4"></v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "DostepneGodzinyPicker",
  props: ["godziny","visible"],
  data()
  {
    return {
      godziny_wybieralne: []
    }
  },
  methods: {
    selectTermin(item) {
      this.$emit('selected',item)
    },
    getFormattedTime(item)
    {
      return dayjs(item.data_start).format("HH:mm")
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    },
  },
  watch: {
    godziny: {
      immediate: true,
      handler(val) {
        if(val != null)
        {
          let localArr = []
          let index = 0
          this.godziny.forEach(elem => {
            localArr.push({
              data_start: elem.data_start,
              data_koniec: elem.data_koniec,
              is_blocked: elem.isBlocked,
              powod: elem.powod,
              selected: false,
              id: index
            })
            index += 1
          })
          this.godziny_wybieralne = localArr
        }
      }
    }
  }
}
</script>

<style scoped>

</style>